export default "__VITE_ASSET__BAe8gawG__"